import { Component, OnInit } from '@angular/core';
import { UiCommonService } from '../../core/services/ui-common.service';
import { LocalStorageService } from 'src/app/modules/core/services/local-storage.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
    breadcrumb$ = this.uiCommonService.breadcrumbSubject$;
    //router: any;

    constructor(
      private uiCommonService: UiCommonService,
      private activatedRoute: ActivatedRoute,
      private router: Router,
      private localStorageService: LocalStorageService) {}
    ngOnInit(): void {}

    clickEvent(){
      var urlString =  window.location.href;

      if(urlString.includes('profile-selection')){
          window.location.href='https://www.gov.gr/ipiresies/periousia-kai-phorologia/diakheirise-akinetes-periousias/metavivasi';
      } else{
        //var paymentStatus = this.activatedRoute.snapshot.queryParamMap.get('paymentStatus');

        //if (this.localStorageService.getRole() === 'CITIZEN' && (paymentStatus === 'success' || paymentStatus === 'failure')) {
        if (urlString.includes('citizen-transaction-contract-cadastre')){
            this.router.navigate(['transaction-list']);
        }
        else {
          window.history.back();
        }
      }
    }
}
